import { Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource, MatTable, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { UpcomingOrdersWithMissingContentService } from './../../services';
import { UpcomingOrdersWithMissingContent } from '../../models/upcoming-orders-with-missing-content';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { RouterLink } from '@angular/router';
import { LoadingSpinnerComponent } from '../../../../shared/components/loading-spinner/loading-spinner.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'insight-upcoming-orders-with-missing-content',
  templateUrl: './upcoming-orders-with-missing-content.component.html',
  styleUrls: ['./upcoming-orders-with-missing-content.component.scss', '../../scss/operational-dashboard-shared.scss'],
  imports: [RouterLink, LoadingSpinnerComponent, MatTable, MatSort, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, DatePipe]
})
export class UpcomingOrdersWithMissingContentComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;

  public upcomingOrdersWithMissingContent = new MatTableDataSource<UpcomingOrdersWithMissingContent>();
  public isLoading = true;
  public didError = false;
  public displayedColumns: string[] = [
    'title',
    'orders',
    'nextDueDateTime'
  ];

  private unsubscribeTrigger$ = new Subject();

  constructor(
    private upcomingOrdersWithMissingContentService: UpcomingOrdersWithMissingContentService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.upcomingOrdersWithMissingContentService.getUpcomingOrdersWithMissingContent()
      .pipe(takeUntil(this.unsubscribeTrigger$))
      .subscribe(
        (results: UpcomingOrdersWithMissingContent[]) => {
          this.upcomingOrdersWithMissingContent = new MatTableDataSource(results);
          this.upcomingOrdersWithMissingContent.sort = this.sort;
          this.isLoading = false;
        },
        (error: any) => {
          this.didError = true;
          this.isLoading = false;
          this.toastr.error('Failed to get Upcoming Orders with Missing Content', 'Error');
        });
  }

  ngOnDestroy() {
    this.unsubscribeTrigger$.next();
    this.unsubscribeTrigger$.complete();
  }
}
